export default __webpack_public_path__ + "static/integrate-seamlessly.url-3041f6f35ea1415168945b427b23984b.svg";